/** ISO 3166-1 alpha-2 codes used by jVectorMap world map → display name for address matching */
export const REGION_CODE_TO_NAME = {
  IN: 'India',
  GB: 'United Kingdom',
  US: 'United States',
  FR: 'France',
  DE: 'Germany',
  IT: 'Italy',
  ES: 'Spain',
  PT: 'Portugal',
  NL: 'Netherlands',
  BE: 'Belgium',
  CH: 'Switzerland',
  AT: 'Austria',
  GR: 'Greece',
  TR: 'Turkey',
  AE: 'United Arab Emirates',
  TH: 'Thailand',
  SG: 'Singapore',
  MY: 'Malaysia',
  ID: 'Indonesia',
  AU: 'Australia',
  NZ: 'New Zealand',
  JP: 'Japan',
  CN: 'China',
  KR: 'South Korea',
  RU: 'Russia',
  BR: 'Brazil',
  MX: 'Mexico',
  CA: 'Canada',
  ZA: 'South Africa',
  EG: 'Egypt',
  MA: 'Morocco',
  KE: 'Kenya',
  NP: 'Nepal',
  LK: 'Sri Lanka',
  MV: 'Maldives',
  BT: 'Bhutan',
  VN: 'Vietnam',
  KH: 'Cambodia',
  PH: 'Philippines',
  HK: 'Hong Kong',
  TW: 'Taiwan',
  IE: 'Ireland',
  NO: 'Norway',
  SE: 'Sweden',
  DK: 'Denmark',
  FI: 'Finland',
  PL: 'Poland',
  CZ: 'Czech Republic',
  HU: 'Hungary',
  HR: 'Croatia',
  IS: 'Iceland',
  QA: 'Qatar',
  SA: 'Saudi Arabia',
  OM: 'Oman',
  JO: 'Jordan',
  IL: 'Israel',
  AR: 'Argentina',
  CL: 'Chile',
  PE: 'Peru',
  CO: 'Colombia',
  TD: 'Chad',
};

/** Match package address text to map region codes */
export const getRegionCodesFromPackages = (packages) => {
  if (!packages?.length) return [];
  const codes = new Set();
  packages.forEach((pkg) => {
    const addr = (pkg.address?.address || '').toLowerCase();
    if (!addr) return;
    Object.entries(REGION_CODE_TO_NAME).forEach(([code, name]) => {
      if (addr.includes(name.toLowerCase())) {
        codes.add(code);
      }
    });
    if (/\buk\b|united kingdom|london|england|scotland|wales|britain|edinburgh|manchester/i.test(addr)) {
      codes.add('GB');
    }
    if (/\buae\b|dubai|abu dhabi/i.test(addr)) {
      codes.add('AE');
    }
  });
  return Array.from(codes);
};

export const filterPackagesByRegion = (packages, regionCode) => {
  if (!regionCode || !packages?.length) return packages ?? [];
  const countryName = REGION_CODE_TO_NAME[regionCode];
  if (!countryName) return packages;
  const needle = countryName.toLowerCase();
  return packages.filter((pkg) =>
    pkg.address?.address?.toLowerCase().includes(needle)
  );
};
